import { Controller } from "@hotwired/stimulus"

// The Blockplan grid: a click sets one week of an Ausbildungsjahr to the kind on the brush,
// Shift+click everything from the previously clicked week of the same row. The server answers
// with the repainted row and block list as Turbo Streams.
//
// Clicks are sent one after another: each one splits or extends the blocks the previous one
// left, so two in flight at once could work on the same block.
//
// A click the server did not take (an error, an expired session that redirects to the sign-in
// page) reloads the page, so the grid never shows weeks that were not saved.
export default class extends Controller {
  static targets = ["brush"]
  static values = { url: String }

  connect() {
    this.queue = Promise.resolve()
    this.anchor = null
  }

  paint(event) {
    const { track, week } = event.params
    const from = event.shiftKey && this.anchor?.track === track ? this.anchor.week : week
    this.anchor = { track, week }

    const body = new FormData()
    body.append("track_id", track)
    body.append("from", from)
    body.append("to", week)
    body.append("kind", this.brush)

    this.queue = this.queue.then(() => this.send(body)).catch(() => this.reload())
  }

  get brush() {
    return this.brushTargets.find((input) => input.checked)?.value
  }

  async send(body) {
    const token = document.head.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      body,
      headers: { "X-CSRF-Token": token, Accept: "text/vnd.turbo-stream.html" },
    })
    const streamed = response.headers.get("Content-Type")?.includes("text/vnd.turbo-stream.html")
    if (!response.ok || response.redirected || !streamed) return this.reload()

    Turbo.renderStreamMessage(await response.text())
  }

  reload() {
    this.anchor = null
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
